import QbHeader from './QbHeader';

export default QbHeader;
